import { render } from "./userHead.vue?vue&type=template&id=00e4c651"
import script from "./userHead.vue?vue&type=script&lang=js"
export * from "./userHead.vue?vue&type=script&lang=js"

import "./userHead.vue?vue&type=style&index=0&id=00e4c651&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__